import React from "react"
import PropTypes from "prop-types"
import InputField from "./InputField"
import ToggleChoiceList from "./ToggleChoiceList"

const BrandAndModel = (props) => {
  const firstChoiceList = props.choices.slice(0, 1)

  return (
    <React.Fragment>
      <InputField
        autoFocus={props.autoFocus}
        prefix={props.prefix}
        value={props.value}
        onChange={props.onChange}
        onKeyDown={props.onKeyDown}
        onBlur={props.onBlur}
        focused={props.focused}
        className={props.classNameInput}
        inputPlaceholder={props.inputPlaceholder}
      />
      <ToggleChoiceList
        possibleCategorizedChoices={firstChoiceList}
        allCategorizedChoices={
          props.value === "" ? props.choices : firstChoiceList
        }
        selectItem={props.selectItem}
        theme={props.theme}
        labels={{
          seeAll: props.labelSeeAll,
          close: props.labelClose,
        }}
      />
    </React.Fragment>
  )
}

BrandAndModel.propTypes = {
  autoFocus: PropTypes.bool.isRequired,
  prefix: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  onBlur: PropTypes.func.isRequired,
  focused: PropTypes.bool.isRequired,
  classNameInput: PropTypes.string.isRequired,
  inputPlaceholder: PropTypes.string.isRequired,
  choices: PropTypes.array.isRequired,
  selectItem: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
  labelSeeAll: PropTypes.string.isRequired,
  labelClose: PropTypes.string.isRequired,
}

export default BrandAndModel
